import { useState } from "react";
import { Asset } from "../models/asset";
import { fetchUptimeAssets } from "../api/fetchAssets";

function useUptimeAssets() {
    const [uptimeAssets, setUptimeAssets] = useState<Asset[]>([]);

    const getUptimeAssets = async (assetIds: string[]) => {
        if(assetIds?.length) {
            const data = await fetchUptimeAssets(assetIds);
            setUptimeAssets([...uptimeAssets, ...data]);
        }
    }

    const refreshUptimeAsset = async (chassis: string) => {
        if(chassis) {
            const data = await fetchUptimeAssets([chassis]);
            if(data?.length > 0) {
                setUptimeAssets(prev => {
                    const filtered = prev.filter(asset => asset.chassis !== chassis);
                    return [...filtered, ...data];
                });
            }
        }
    }

    return { uptimeAssets, getUptimeAssets, refreshUptimeAsset }
}

export default useUptimeAssets;